import { Sprite, Texture, Container } from 'pixi.js';
import { InteractionEvents, Tween } from "@cc/pixi-app";
import { ScreenBase } from "./ScreenBase";
import { ButtonBase } from '../common/ButtonBase';
import { FluffyCloud } from '../common/FluffyCloud';
import { LoadScreen } from './../loader';
import { dataImporter } from './../DataImporter';

/**
 */
export class ScreenSplash extends ScreenBase {
    /**
     */
    init() {
        ScreenBase.addFpsCounter();
        nick_sdk_client.GameEventEmitter.sendGameEvent(
            nick_sdk_client.GameEventEmitter.ON_TITLE_SCREEN_START
        );

        // Check what splash screen we need to show.
        this.splashData = dataImporter.packs && dataImporter.packs.length === 1 && dataImporter.packs[0].soloSplash ?
            dataImporter.packs[0].soloSplash : dataImporter.data.game.splash;

        this.app.screenManager.setLoaderDisplayCtor(LoadScreen);
        this.app.sound.play("01-main-menu");

        this.background = Sprite.from('hills_bg');
        this.background.height = this.app.resizer.height;
        this.background.anchor.set(0.5);
        this.addChild(this.background);

        new FluffyCloud(this.background.width / 2, -this.background.width / 2, -100, -this.background.height / 2, this.background, this);
        new FluffyCloud(this.background.width / 2, -this.background.width / 2, -100, -this.background.height / 2, this.background, this, 1);
        new FluffyCloud(this.background.width / 2, -this.background.width / 2, -100, -this.background.height / 2, this.background, this);
        new FluffyCloud(this.background.width / 2, -this.background.width / 2, -100, -this.background.height / 2, this.background, this, 1);
        new FluffyCloud(this.background.width / 2, -this.background.width / 2, -100, -this.background.height / 2, this.background, this);
        new FluffyCloud(this.background.width / 2, -this.background.width / 2, -100, -this.background.height / 2, this.background, this, 1);
        new FluffyCloud(this.background.width / 2, -this.background.width / 2, -100, -this.background.height / 2, this.background, this);
        new FluffyCloud(this.background.width / 2, -this.background.width / 2, -100, -this.background.height / 2, this.background, this, 1);

        this.lights = Sprite.from('light_beams');
        this.lights.anchor.set(0.5);
        this.lights.y = 170;
        this.lights.scale.set(0);
        this.background.addChild(this.lights);

        this.characters = new Container();
        this.characters.scale.set(0.4);
        this.lights.addChild(this.characters);

        // Add all the characters we've been given by the data.
        for (let i = 0; i < this.splashData.chars.length; i++) {
            const charData = this.splashData.chars[i];

            let char = Sprite.from(charData.img);
            char.anchor.set(0.5);
            if (charData.x) char.x = charData.x;
            if (charData.y) char.y = charData.y;
            this.characters.addChild(char);
        }

        this.tween(this.lights.scale, { loop: false, })
            .to({ x: 2, y: 2 }, 500, createjs.Ease.sineInOut);
        this.wait(500).call(() => this.animateCharacters());

        //Animate logo
        this.logoText = Sprite.from('brand-logo');
        this.logoText.anchor.set(0.5);
        this.logoText.y = -190;
        this.logoText.scale.set(0.7);

        if (this.splashData.logo) {
            this.brandLogo = Sprite.from(this.splashData.logo);
            this.brandLogo.anchor.set(0.5);
            if (this.splashData.logoPos && this.splashData.logoPos.x) this.brandLogo.x = this.splashData.logoPos.x;
            if (this.splashData.logoPos && this.splashData.logoPos.y) this.brandLogo.y = this.splashData.logoPos.y;
            this.logoText.addChild(this.brandLogo);
        }

        this.tween(this.logoText, { loop: true, })
            .wait(500)
            .to({ y: -160 }, 2500, createjs.Ease.sineInOut)
            .to({ y: -190 }, 2500, createjs.Ease.sineInOut);

        //Animate button
        this.playButton = new ButtonBase(new Texture.from('play-btn'));
        this.playButton.y = 130;
        this.playButton.anchor.set(0.5);
        this.playButton.on(InteractionEvents.PointerTap, this.onPlayClick, this);
        this.playButton.interactive = true;
        this.tween(this.playButton.scale, { loop: true, })
            .to({ x: 0.93, y: 0.93 }, 900, createjs.Ease.sineInOut)
            .to({ x: 1, y: 1 }, 900, createjs.Ease.sineInOut);

        this.ui.addChild(this.createMuteButton('TopRight'));
        this.background.addChild(this.logoText);
        this.background.addChild(this.playButton);
    }

    /**
     */
    start() {

    }

    /**
     */
    transitionIn() { }

    resize() {
        this.background.height = this.app.resizer.height;
        this.background.scale.x = this.background.scale.y;
    }

    animateCharacters() {
        this.tween(this.lights.scale, { loop: true, })
            .to({ x: 1.9, y: 1.9 }, 3000, createjs.Ease.sineInOut)
            .to({ x: 2, y: 2 }, 3000, createjs.Ease.sineInOut);
    }

    onPlayClick() {
        this.app.sound.play("02-ui-click");
        Tween.removeContainerTweens(this);
        this.playButton.interactive = false;
        this.tween(this.playButton.scale, { override: true })
            .to({ x: 0, y: 0 }, 500, createjs.Ease.getElasticIn(1.1, 1.5));
        this.tween(this.logoText)
            .to({ y: -1000 }, 750, createjs.Ease.getElasticIn(1.1, 1.5));
        this.wait(1000).call(() => this.app.showScreen('avatarCreator'));

        nick_sdk_client.GameEventEmitter.sendGameEvent(
            nick_sdk_client.GameEventEmitter.ON_TITLE_SCREEN_START
        );
    }
}
